import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../../config';
import { headers } from '../../token';
import Swal from 'sweetalert2';
import validateError from '../../ValidateError';

const server_backend = config.API_URL;

function CreateGroup({ username }) {

    const [objectList, setObjectList] = useState([]);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        comment: '',
        objects_add: '',
        user_transaction: username
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleCheckboxChange = (obj_ID) => {
        const currentIndex = formData.objects_add.split(',').map(Number).indexOf(obj_ID);
        const newChecked = [...formData.objects_add.split(',').map(Number)];

        if (currentIndex === -1) {
            newChecked.push(obj_ID);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setFormData({
            ...formData,
            objects_add: newChecked.join(',')
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        try {
            const response = await axios.post(`${server_backend}/groups/insert`, formData, headers);

            if (response.data.RES_CODE === "00") {
                Swal.fire({
                    icon: 'success',
                    title: 'Created Successfully',
                    showConfirmButton: false,
                    timer: 2000
                });
                navigate('/groups');
                setFormData({
                    name: "",
                    comment: "",
                    objects_add: '',
                    user_transaction: username
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'There is already a Group with the same name, please try with another name',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const message = validateError(error);

            Swal.fire({
                icon: 'error',
                title: message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    };

    useEffect(() => {
        const getObject = async () => {
            try {
                const response = await axios.get(`${server_backend}/objects/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setObjectList(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log("Unexpected error, please check")
            }
        }
        getObject();
    }, []);

    const validateForm = () => {
        const { name } = formData;
        const newErrors = {};

        if (name.length < 3) {
            newErrors.name = 'Name is required';
        }


        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xxl-6">
                        <div className="card">
                            <div className="card-header align-items-center d-flex">
                                <Link className='btn btn-warning' to="/Groups">
                                    Go Back
                                </Link>
                            </div>

                            <div className="card-body">
                                <center>
                                    <i className="bx bx-group" style={{ fontSize: "70px", opacity: "0.8" }}></i>
                                    <p className="text-muted">
                                        Corresponding form to create the Group
                                    </p>
                                </center>

                                <div className="live-preview">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label htmlFor="name" className="form-label">Name</label>
                                                    <span className="text-danger" style={{marginLeft: "5px"}}>*</span>
                                                    <input
                                                        type="text"
                                                        className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                                        id="name"
                                                        name="name"
                                                        value={formData.name}
                                                        onChange={handleChange}
                                                    />
                                                    {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label htmlFor="comment" className="form-label">Comment</label>
                                                    <textarea
                                                        className="form-control"
                                                        placeholder="Enter comment"
                                                        id="comment"
                                                        name="comment"
                                                        value={formData.comment}
                                                        onChange={handleChange}
                                                    ></textarea>
                                                </div>
                                            </div>
                                            {/* User Groups */}
                                            <h4 className='p-4'>Object</h4>
                                            <div className="col-md-12 mb-3 p-4">
                                                <div className="row">
                                                    {objectList.map(object => (
                                                        <div className="col-md-3 form-check mb-3" key={object.obj_ID}>
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                id={`group-${object.obj_ID}`}
                                                                checked={formData.objects_add.split(',').map(Number).includes(object.obj_ID)}
                                                                onChange={() => handleCheckboxChange(object.obj_ID)}
                                                            />
                                                            <label className="form-check-label" htmlFor={`group-${object.obj_ID}`}>
                                                                {object.name}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label htmlFor="user_transaction" className="form-label">User Transaction</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter user transaction"
                                                        id="user_transaction"
                                                        value={username}
                                                        name="user_transaction"
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="text-end">
                                                    <button type="submit" className="btn btn-primary">Submit</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreateGroup;
